// extracted by mini-css-extract-plugin
export default {"close":"QrModal_close__xJZ2o"};